import { Client } from "@/clients/client";
import {
  PaginatedResponse,
  RvsCalculationJob,
  RvsRawDataFile,
  RvsRawDataFileParams,
  ThresholdFmFilesResponse,
  ThresholdFmResponse,
  ThresholdFmRow,
} from "@/clients/RvsCalculationClient";

export class RvsCalculationService {
  constructor(private client: Client) {}

  public async getSensorIds(search?: string): Promise<string[]> {
    return this.client.rvsCalculationClient.getSensorIds(search);
  }

  public async getRawDataFiles(params: RvsRawDataFileParams): Promise<PaginatedResponse<RvsRawDataFile>> {
    return this.client.rvsCalculationClient.getRawDataFiles(params);
  }

  public async createJob(fileIds: number[]): Promise<{ jobId: number }> {
    return this.client.rvsCalculationClient.createJob(fileIds);
  }

  public async getJob(jobId: number): Promise<RvsCalculationJob> {
    return this.client.rvsCalculationClient.getJob(jobId);
  }

  public async getActiveJob(): Promise<RvsCalculationJob | null> {
    return this.client.rvsCalculationClient.getActiveJob();
  }

  public async getThresholdFm(sensorId: string): Promise<ThresholdFmResponse> {
    return this.client.rvsCalculationClient.getThresholdFm(sensorId);
  }

  public async updateThresholdFm(sensorId: string, rows: ThresholdFmRow[]): Promise<ThresholdFmResponse> {
    return this.client.rvsCalculationClient.updateThresholdFm(sensorId, rows);
  }

  public async getThresholdFmFiles(sensorId: string, dateFrom?: string, dateTo?: string): Promise<ThresholdFmFilesResponse> {
    return this.client.rvsCalculationClient.getThresholdFmFiles(sensorId, dateFrom, dateTo);
  }

  public async createThresholdFmJob(sensorId: string, dateFrom: string, dateTo: string): Promise<{ jobId: number }> {
    return this.client.rvsCalculationClient.createThresholdFmJob(sensorId, dateFrom, dateTo);
  }
}
